import { AdvancedType } from "src/modules/utils/shared/advanced-type";
import { EnaioCall } from "./EnaioCall";

export class EnaioCallSaveWorkflowScript extends EnaioCall <boolean> {
    organisationId: string;
    modelId: string;
    scriptId: string;
    scriptLanguage = 0;
    code: string;
    getModelType(): AdvancedType {
        return AdvancedType.ofPrimitive("boolean");
    }

}
